import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCountryInfoDS } from "@EUForms/selectors";
import { countryInfoKeys } from "../../util/fieldPatterns";


const  CountryInfoDetail=({saveData,updateData,renderForm,fieldPattern,validateError,updateHeaderData})=>{
    const dispatch=useDispatch()
    const dataSource=useSelector(selectCountryInfoDS)
    const isDiscrepanciesExist = useSelector((state) => state.transportReducer.isDiscrepanciesExist)

    const onChange=useCallback(({target:{value,name}},data, otherFields={})=>dispatch(updateData({key:"countryInfo",data:{[name]:value,...otherFields}})),[updateData])
    const onBlur=useCallback(({target:{value,name}},data, otherFields={})=>saveData({"countryInfo":{[name]:value || " ",...otherFields}}),[saveData])
    
    const onSelect=useCallback((e, {value,name})=>{

      validateError &&
      validateError(
        { countryInfo: { [name]: value} },
        {
          [countryInfoKeys[name]]:
          fieldPattern()?.transportTab?.countryInfo?.[countryInfoKeys[name]]
        }
      )

        const response={}
        if(name=="originCountry")
            response.placeOfLoading=" "
        else if (name=="destinationCountry")
            response.placeOfUnloading=" "
        onChange({target: {value:value.trim(),name}},{}, response);
        onBlur({target: {value,name}},{},response)
        ,[onChange,onBlur]
    })
     const onHeaderDataSelect = useCallback(
       (e, { value, name }) => {
         dispatch(updateHeaderData({ [name]: value?.trim() }))
         saveData({ [name]: value || ' ' })
       },
       [updateData, saveData]
     )
   
  
  return (
    renderForm && renderForm({ onSelect, dataSource, isDiscrepanciesExist, onHeaderDataSelect })
  )
}


export default CountryInfoDetail